export const selectShoppingLists = (state) => ({
    pages: state.shoppingLists.pages,
    pagination: state.shoppingLists.pagination,
});
